export default __webpack_public_path__ + "3db65dc4b858f0fed4fb155f8a5ecab9.woff";